import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppConstatnts } from 'src/app/common/constants/app-contstants';

@Component({
  selector: 'app-editor',
  templateUrl: './editor-template.component.html',
  styleUrls: ['./editor-template.component.scss']
})
export class EditorTemplateComponent implements OnInit {

  showMemberEditor: boolean = false;
  showFamilyEditor: boolean = false;
  showSourceEditor: boolean = false;
  showPlaceEditor: boolean = false;
  showLeftPanel: boolean = true;
  isLeftPanelVisible: boolean = true;
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateEditorVisibility(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit(): void {
    this.updateEditorVisibility(this.router.url);
  }

  private updateEditorVisibility(currentUrl: string) {
    this.showMemberEditor = currentUrl.includes(AppConstatnts.routerModes.IndividualEditor);
    this.showFamilyEditor = currentUrl.includes(AppConstatnts.routerModes.FamilyEditor);
    this.showSourceEditor = currentUrl.includes(AppConstatnts.routerModes.SourceEditor);
    this.showPlaceEditor = currentUrl.includes(AppConstatnts.routerModes.PlaceEditorPage);
    if (this.showSourceEditor || this.showPlaceEditor) {
      this.showLeftPanel = false;
      this.isLeftPanelVisible = false;
    } 
    else {
      this.showLeftPanel = true;
      this.isLeftPanelVisible = true;
    }
  }

  onLeftPanelToggle(state: boolean) {
    this.isLeftPanelVisible = state;
  }

}
